export default __webpack_public_path__ + "static/media/ca-ontario-kings-jct.1d86064d.svg";